const state = {
    time: 0
};
const mutations = {
    setSaveTime: (state:any, time:number) => {
        state.time = time;
    }
};

export default {
    namespaced: true, // 这个是命名空间，用来区分不同的模块，我是根据文件的名字来区分
    state,
    mutations
};
